import React, { Component, PropTypes } from 'react';
import {
  Styles,
  FlatButton,
  IconButton,
  Dialog,
  Toggle,
  TextField
} from 'material-ui';
import ClassNames from 'classnames';
import * as Icons from 'components/Material/SvgIcons';
import * as Colors from 'components/Material/Styles/Colors';
import DialogPortal from 'components/DialogPortal';
import { findDOMNode } from 'react-dom';
import { FlexBox } from 'components';
import pageModuleStyles from 'components/Page/Module/Styles';
import { Toolbar, ToolbarGroup, ToolbarButton } from 'components/Toolbar';

import moduleStyles from 'components/Page/Module/Styles';

const { Spacing } = Styles;

const actions = [
  {
    link: { icon: 'EditorInsertLink' }
  },
  {
    undo: { icon: 'ContentUndo' },
    redo: { icon: 'ContentRedo', mode: 'advanced' }
  },
  {
    bold: { text: '<b>B</b>' },
    italic: { text: '<i>I</i>' },
    underline: { text: '<u>U</u>', mode: 'advanced' },
    strikeThrough: { text: '<s>S</s>', mode: 'advanced' }
  },
  {
    justifyLeft: { icon: 'EditorFormatAlignLeft', mode: 'advanced' },
    justifyCenter: { icon: 'EditorFormatAlignCenter', mode: 'advanced' },
    justifyRight: { icon: 'EditorFormatAlignRight', mode: 'advanced' },
    justifyFull: { icon: 'EditorFormatAlignJustify', mode: 'advanced' }
  },
  {
    indent: { icon: 'EditorFormatIndentIncrease', mode: 'advanced' },
    outdent: { icon: 'EditorFormatIndentDecrease', mode: 'advanced' }
  },
  {
    insertUnorderedList: { icon: 'EditorFormatListBulleted' },
    insertOrderedList: { icon: 'EditorFormatListNumbered' }
  },
  {
    h1: { action: 'formatBlock', text: 'h<sub>1</sub>' },
    h2: { action: 'formatBlock', text: 'h<sub>2</sub>' },
    h3: { action: 'formatBlock', text: 'h<sub>3</sub>', mode: 'advanced' },
    h4: { action: 'formatBlock', text: 'h<sub>4</sub>', mode: 'advanced' },
    h5: { action: 'formatBlock', text: 'h<sub>5</sub>', mode: 'advanced' },
    h6: { action: 'formatBlock', text: 'h<sub>6</sub>', mode: 'advanced' },
    p: { action: 'formatBlock', text: 'p' },
    clearFormatting: { action: 'clearFormatting', icon: 'EditorFormatClear' }
  },
  {
    quote: { action: 'quote', text: '"', mode: 'advanced' },
    subscript: { text: 'x<sub>2</sub>', mode: 'advanced' },
    superscript: { text: 'x<sup>2</sup>', mode: 'advanced' }
  }
  // html:          {text: 'html'},
];

const styles = {
  button: {
    lineHeight: `${36}px`,
    width: 36,
    height: 36,
    minWidth: 36,
    // margin: Spacing.desktopGutterMini / 2,
    verticalAlign: 'middle'
  },
  iconButton: {
    lineHeight: `${36}px`,
    backgroundColor: Colors.Colors.fullWhite,
    margin: 0,
    padding: 6,
    borderRadius: 2,
    width: 36,
    height: 36,
    verticalAlign: 'middle'
  },
  icon: {
    margin: 6
  },
  toolbar: {
    backgroundColor: Colors.Colors.grey[200].material,
    borderStyle: 'none none solid none',
    borderWidth: 1,
    borderColor: Colors.Colors.grey[300].material
  },
  root: {
    minHeight: Spacing.desktopKeylineIncrement * 2
  },
  editable: {
    minHeight: Spacing.desktopKeylineIncrement * 4
    // border: `solid 1px ${Colors.Colors.grey[300].material}`
  },
  contentEditable: {
    outline: 'none',
    padding: Spacing.desktopGutterMini,
    overflow: 'auto',
    minHeight: Spacing.desktopKeylineIncrement * 4,
    maxHeight: Spacing.desktopKeylineIncrement * 6
  },
  content: {},
  toolbarGroup: pageModuleStyles.toolbarGroup
};

let attributeWhitelist = {
  href: true,
  src: true,
  target: true
};

let tagWhitelist = {
  // font: true,
  br: true
};

export default class Ozitor extends Component {
  state = {
    html: this.props.content || this.props.defaultContent,
    defaultContent: this.props.defaultContent || this.props.content,
    mode: 'simple'
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  static propTypes = {
    content: PropTypes.string,
    defaultContent: PropTypes.string,
    controls: PropTypes.bool,
    removeStyle: PropTypes.bool,
    editable: PropTypes.bool,
    dark: PropTypes.bool
  };

  static defaultProps = {
    dark: true,
    controls: true,
    editable: true,
    removeStyle: true
  };

  stripAttributes(element) {
    for (let i = element.attributes.length - 1; i >= 0; i--) {
      const attribute = element.attributes[i];
      if (!attributeWhitelist[attribute.name]) {
        element.removeAttribute(attribute.name);
      }
    }
  }

  removeStyle(all) {
    let i = all.length;
    while (i--) {
      const element = all[i];
      if (!tagWhitelist[element.tagName.toLowerCase()]) {
        const isHidden = element.style.display === 'none';
        this.stripAttributes(element);
        if (isHidden) {
          element.style.display = 'none';
        }
        if (!element.hasChildNodes() && element.parentNode) {
          element.parentNode.removeChild(element);
        }
        if (
          !element.hasChildNodes() &&
          element.parentNode &&
          element.innerText.trim() === ''
        ) {
          element.parentNode.removeChild(element);
        }
      }
    }
  }

  selectNode() {
    const selection = window.getSelection();
    let node = selection.anchorNode;
    const containers = {
      p: true,
      div: true,
      ul: true,
      ol: true,
      h1: true,
      h2: true,
      h3: true,
      h4: true,
      h5: true,
      blockquote: true
    };
    while (node && containers[node.nodeName]) {
      node = node.parentNode;
    }

    if (node) {
      this.saveSelection();
      const range = document.createRange();
      range.selectNodeContents(node);
      selection.addRange(range);

      this.restoreSelection();
    }
  }

  quote() {
    document.execCommand(
      'insertHTML',
      false,
      "<div class='quote'>" + document.getSelection() + '</div>'
    );
  }

  clearFormatting() {
    if (this.hasSelection()) {
      document.execCommand('removeformat', false, null);
      document.execCommand('formatBlock', false, 'p');
    } else {
      this.saveSelection();
      this.selectNode();
      // this.replaceWithOwnChildren(node)

      this.removeSelectedElements([
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'i',
        's',
        'em',
        'strong',
        'li',
        'ul',
        'ol',
        'blockquote'
      ]);
      this.restoreSelection();
    }
    this.onChange();
  }

  nextNode(originalNode) {
    let node = originalNode;
    if (node.hasChildNodes()) {
      return node.firstChild;
    }
    while (node && !node.nextSibling) {
      node = node.parentNode;
    }
    if (!node) {
      return null;
    }
    return node.nextSibling;
  }

  getRangeSelectedNodes(range, includePartiallySelectedContainers) {
    let node = range.startContainer;
    const endNode = range.endContainer;
    let rangeNodes = [];

    // Special case for a range that is contained within a single node
    if (node === endNode) {
      rangeNodes = [node];
    } else {
      // Iterate nodes until we hit the end container
      while (node && node !== endNode) {
        rangeNodes.push(node === this.nextNode(node));
      }

      // Add partially selected nodes at the start of the range
      node = range.startContainer;
      while (node && node !== range.commonAncestorContainer) {
        rangeNodes.unshift(node);
        node = node.parentNode;
      }
    }

    // Add ancestors of the range container, if required
    if (includePartiallySelectedContainers) {
      node = range.commonAncestorContainer;
      while (node) {
        rangeNodes.push(node);
        node = node.parentNode;
      }
    }

    return rangeNodes;
  }

  getSelectedNodes() {
    const nodes = [];
    if (window.getSelection) {
      const sel = window.getSelection();
      for (let i = 0, len = sel.rangeCount; i < len; ++i) {
        nodes.push.apply(
          nodes,
          this.getRangeSelectedNodes(sel.getRangeAt(i), true)
        );
      }
    }
    return nodes;
  }

  replaceWithOwnChildren(el) {
    const parent = el.parentNode;
    while (el.hasChildNodes()) {
      parent.insertBefore(el.firstChild, el);
    }
    parent.removeChild(el);
  }

  removeSelectedElements(tagNames) {
    this.getSelectedNodes().forEach(node => {
      if (
        node.nodeType === 1 &&
        tagNames.indexOf(node.tagName.toLowerCase()) > -1
      ) {
        // Remove the node and replace it with its children
        this.replaceWithOwnChildren(node);
      }
    });
  }

  format(action, alternativeAction) {
    if (this[action]) {
      this[action].apply(this, []);
    } else if (alternativeAction) {
      document.execCommand(alternativeAction, false, action);
    } else {
      document.execCommand(action, false, null);
    }
    this.onChange();
    findDOMNode(this.refs.editor).focus();
  }

  onChange() {
    const html = findDOMNode(this.refs.editor).innerHTML;
    if (html !== this.state.html) {
      this.setState({ html });
      if (this.props.onChange) {
        this.props.onChange(findDOMNode(this.refs.editor).innerHTML);
      }
    }
  }

  hasSelection() {
    const selection = window.getSelection();
    if (selection.getRangeAt && selection.rangeCount) {
      let length = 0;
      for (let i = 0, len = selection.rangeCount; i < len; ++i) {
        const range = selection.getRangeAt(i);
        length += Math.abs(range.endOffset - range.startOffset);
      }
      return length > 0;
    }
    return false;
  }

  onPaste() {
    setTimeout(() => {
      if (this.props.removeStyle) {
        this.removeStyle(
          findDOMNode(this.refs.editor).getElementsByTagName('*')
        );
      }
      this.setState({ html: findDOMNode(this.refs.editor).innerHTML });
      if (this.props.onChange) {
        this.props.onChange(findDOMNode(this.refs.editor).innerHTML);
      }
    }, 50);
  }

  getValue() {
    return findDOMNode(this.refs.editor).innerHTML;
  }

  getContentStyle() {
    const { style } = this.props;
    return Object.assign(
      {},
      styles.root,
      this.props.editable ? styles.contentEditable : {},
      style && style.content
    );
  }

  getRootStyle() {
    const { style } = this.props;
    return Object.assign(
      {},
      styles.root,
      this.props.editable ? styles.editable : {},
      style && style.root
    );
  }

  saveSelection() {
    if (window.getSelection) {
      let sel = window.getSelection();
      if (sel.getRangeAt && sel.rangeCount) {
        let ranges = [];
        for (let i = 0, len = sel.rangeCount; i < len; ++i) {
          ranges.push(sel.getRangeAt(i));
        }
        this.savedSelection = ranges;
      }
    } else if (document.selection && document.selection.createRange) {
      this.savedSelection = document.selection.createRange();
    }
  }

  restoreSelection() {
    let savedSel = this.savedSelection;
    if (savedSel) {
      if (window.getSelection) {
        let sel = window.getSelection();
        sel.removeAllRanges();
        for (let i = 0, len = savedSel.length; i < len; ++i) {
          sel.addRange(savedSel[i]);
        }
      } else if (document.selection && savedSel.select) {
        savedSel.select();
      }
      this.savedSelection = null;
    }
  }

  link() {
    this.refs.linkDialog.show();
  }

  extendSelectionToWord() {
    let sel;
    if (window.getSelection && (sel = window.getSelection()).modify) {
      // let selectedRange = sel.getRangeAt(0);
      sel.collapseToStart();
      sel.modify('move', 'backward', 'word');
      sel.modify('extend', 'forward', 'word');
    } else if ((sel = document.selection) && sel.type !== 'Control') {
      let range = sel.createRange();
      range.collapse(true);
      range.expand('word');
    }
  }

  confirmLink() {
    let url = this.refs.linkUrl.getValue(),
      openInNewTab = this.refs.linkTarget.isToggled();

    this.refs.linkDialog.dismiss();
    findDOMNode(this.refs.editor).focus();
    this.restoreSelection();
    this.refs.linkUrl.setValue('http://');
    if (openInNewTab) {
      document.execCommand(
        'insertHTML',
        false,
        `<a href='${url}' target='_blank'>${this.linkText}</a>`
      );
    } else {
      document.execCommand(
        'insertHTML',
        false,
        `<a href='${url}' >${this.linkText}</a>`
      );
    }
    if (this.props.onChange) {
      this.props.onChange(findDOMNode(this.refs.editor).innerHTML);
    }
  }

  restore() {
    this.restoreSelection();
  }

  fillLinkDefaults() {
    let selection, selectedText;
    if (window.getSelection) {
      selection = window.getSelection();
      selectedText = selection.toString();
    } else if (document.selection && document.selection.type !== 'Control') {
      selection = document.selection;
      selectedText = selection.toString();
    }
    if (!selectedText) {
      this.extendSelectionToWord();
      selectedText = selection.toString();
    }

    let parentNode = selection.anchorNode && selection.anchorNode.parentNode;
    if (parentNode && parentNode.tagName.toLowerCase() === 'a') {
      selectedText = this.selectElementContents(parentNode);

      this.refs.linkUrl.setValue(parentNode.href);
      this.refs.linkTarget.setToggled(parentNode.target === '_blank');
    }
    this.saveSelection();
    this.linkText = selectedText;
  }

  selectElementContents(el) {
    let range = document.createRange();
    range.selectNodeContents(el);
    let sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    return sel.toString();
  }

  toggleMode() {
    if (this.state.mode === 'simple') {
      this.setState({ mode: 'advanced' });
    } else {
      this.setState({ mode: 'simple' });
    }
  }

  render() {
    let controls;
    let buttons = [];
    let standardActions = [
      <FlatButton
        key="ok"
        label={this.context.getIntlMessage('OK')}
        secondary={true}
        onTouchTap={::this.confirmLink}
      />
    ];
    const { extraControls } = this.props;
    const props = {
      // className: 'ozitor-content',
      onBlur: this.onChange.bind(this),
      onKeyUp: this.onChange.bind(this),
      onCopy: this.onChange.bind(this),
      onPaste: this.onPaste.bind(this),
      onCut: this.onChange.bind(this),
      onMouseup: this.onChange.bind(this),
      dangerouslySetInnerHTML: { __html: this.state.defaultContent }
    };
    if (this.props.editable) {
      props.contentEditable = true;
      if (this.props.controls) {
        buttons = actions.map((actionGroup, groupIndex) => {
          const groupControls = Object.keys(actionGroup)
            .map(actionName => {
              const action = actionGroup[actionName];
              if (action.mode && action.mode !== this.state.mode) {
                return null;
              }
              if (action.icon) {
                const Icon = Icons[action.icon];
                return (
                  <ToolbarButton
                    onTouchTap={this.format.bind(
                      this,
                      actionName,
                      action.action
                    )}
                    key={actionName}
                  >
                    <Icon />
                  </ToolbarButton>
                );
              }
              return (
                <ToolbarButton
                  onTouchTap={this.format.bind(this, actionName, action.action)}
                  key={actionName}
                >
                  <span dangerouslySetInnerHTML={{ __html: action.text }} />
                </ToolbarButton>
              );
            })
            .filter(control => !!control);
          if (groupControls.length && groupControls.length > 0) {
            return (
              <ToolbarGroup key={groupIndex}>{groupControls}</ToolbarGroup>
            );
          }
        });
        let switchIcon;
        let tooltip;
        if (this.state.mode === 'simple') {
          tooltip = this.context.getIntlMessage('ozitor.more');
          switchIcon = <Icons.NavigationMoreVert />;
        } else {
          tooltip = this.context.getIntlMessage('ozitor.less');
          switchIcon = <Icons.NavigationMoreHoriz />;
        }
        controls = (
          <Toolbar>
            {buttons}
            <ToolbarGroup right>
              <ToolbarButton tooltip={tooltip} onTouchTap={::this.toggleMode}>
                {switchIcon}
              </ToolbarButton>
            </ToolbarGroup>
            {extraControls}
          </Toolbar>
        );
      }
    }
    return (
      <div
        className={ClassNames('ozitor')}
        style={this.getRootStyle(styles.root)}
      >
        {controls}
        <div ref="editor" {...props} style={this.getContentStyle()} />
        <DialogPortal>
          <Dialog
            onShow={::this.fillLinkDefaults}
            onDismiss={::this.restore}
            ref="linkDialog"
            title={this.context.getIntlMessage('ozitor.createLink')}
            actions={standardActions}
            dismissOnClickAway={true}
          >
            <TextField
              fullWidth={true}
              ref="linkUrl"
              defaultValue={'http://'}
              floatingLabelText={this.context.getIntlMessage('ozitor.url')}
            />
            <Toggle
              label={this.context.getIntlMessage('ozitor.openInNewTab')}
              ref="linkTarget"
            />
          </Dialog>
        </DialogPortal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Widgets/Ozitor.js